import React, { CSSProperties, FC, ReactElement, ReactNode, useState } from 'react'

import styles from '../styles/Modal.module.scss'
import iconStyles from '../styles/Icon.module.scss'
import { Icon } from './icons/Icon'

interface ModalProps {
	visible: boolean
	title: ReactNode
	content: ReactElement | string
	footer?: ReactElement | string
	style?: CSSProperties
	stickyHeaderFooter?: boolean
	closeOnBackdrop?: boolean
	onClose: () => void
}

const Modal: FC<ModalProps> = ({
	visible,
	title,
	content,
	footer,
	style = { width: '650px' },
	stickyHeaderFooter = false,
	closeOnBackdrop = false,
	onClose,
}) => {
	const [hidingProceed, setHidingProceed] = useState(false)
	const [bodyScrolled, setBodyScrolled] = useState(false)

	const onKeydown = ({ key }: KeyboardEvent) => {
		switch (key) {
			case 'Escape':
				setHidingProceed(true)
				setTimeout(() => {
					onClose()
					setHidingProceed(false)
				}, 300)
				break
		}
	}

	const onCloseRef = () => {
		setHidingProceed(true)
		setTimeout(() => {
			onClose()
			setHidingProceed(false)
		}, 300)
	}

	React.useEffect(() => {
		document.addEventListener('keydown', onKeydown)
		return () => document.removeEventListener('keydown', onKeydown)
	})

	if (!visible) return null

	return (
		<div
			className={styles.modal}
			style={{ opacity: hidingProceed ? '0' : '1' }}
			onClick={(event) => {
				if (closeOnBackdrop && event.target === event.currentTarget) onClose()
			}}
		>
			<div className={`${styles.modal_dialog} ${stickyHeaderFooter ? styles.modal_dialog_stickyHeaderFooter : ''}`} style={style} onClick={(e) => e.stopPropagation()}>
				<div className={`${styles.modal_header} ${stickyHeaderFooter && bodyScrolled ? styles.modal_header_scrolled : ''}`}>
					<h3
						className={styles.modal_header__title}
						style={{
							textAlign: 'center',
						}}
					>
						{title}
					</h3>
					<span className={styles.modal_header__close} onClick={onCloseRef}>
						<Icon variant={'xmark'} className={iconStyles.default} />
					</span>
				</div>
				<div
					className={styles.modal_body}
					onScroll={stickyHeaderFooter ? (event) => setBodyScrolled(event.currentTarget.scrollTop > 0) : undefined}
					style={{
						padding: '0px 0px',
					}}
				>
					<div className={styles.modal_body__content}>{content}</div>
				</div>
				{footer && <div className={styles.modal_footer}>{footer}</div>}
			</div>
		</div>
	)
}

export default Modal
